export const PATIENT_DETAIL_PAGE_THEME = 'indigo';

/** Top-level patient profile tabs. Appointments / Activity / Invalid stack under Patient Info. */
export const PATIENT_DETAIL_TAB_CONFIG = [
    { id: 'overview', label: 'Patient Info', icon: 'bi-person-vcard', theme: 'indigo' },
    { id: 'comm-pref', label: 'Communication', icon: 'bi-chat-square-text', theme: 'success' },
];

export const PATIENT_CONTACT_THEMES = {
    email: 'pink',
    cell: 'success',
    phone: 'cyan',
    address: 'orange',
};

export const PATIENT_META_THEMES = {
    pms: 'slate',
    dob: 'orange',
    gender: 'purple',
    doctor: 'cyan',
};

export const PATIENT_QUICK_ACTIONS = [
    { icon: 'bi-envelope', label: 'Send Email', contactKey: 'email', prefKey: 'isEmail', theme: 'pink' },
    { icon: 'bi-chat-dots', label: 'Send SMS', contactKey: 'cell', prefKey: 'isSms', theme: 'success' },
    { icon: 'bi-clipboard-data', label: 'Send Survey', contactKey: 'email', prefKey: 'isSurvey', theme: 'teal' },
    { icon: 'bi-file-text', label: 'Send Articles', contactKey: 'email', prefKey: 'isArticle', theme: 'orange' },
    { icon: 'bi-eyeglasses', label: 'Glass Pickup', prefKey: 'isGlass', theme: 'violet' },
    { icon: 'bi-eye', label: 'Lens Pickup', prefKey: 'isLens', theme: 'cyan' },
    { icon: 'bi-heart', label: 'Thank You', prefKey: 'isThankyou', theme: 'danger' },
    { icon: 'bi-emoji-smile', label: 'Welcome', disableIfWelcomeSent: true, theme: 'warning' },
];

export const PATIENT_CHANNEL_THEMES = {
    isEmail: 'pink',
    isSms: 'success',
    isCall: 'cyan',
};

export const PATIENT_PREF_SECTION_THEMES = {
    channels: 'cyan',
    notifications: 'orange',
};

export const PATIENT_NOTIFICATION_THEMES = {
    isReminder: 'orange',
    isNewsletter: 'pink',
    isArticle: 'orange',
    isRecall: 'purple',
    isGlass: 'violet',
    isLens: 'cyan',
    isLensOrder: 'indigo',
    isSurvey: 'teal',
    isThankyou: 'danger',
    isFollowup: 'primary',
    isBirthday: 'warning',
};
